var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lw-overlay',{attrs:{"size":'c1',"colour":'cream',"close-to":'rates'}},[_c('div',{staticClass:"grid grid-columns-4_md"},[_c('transition',{attrs:{"name":_vm.transitionName,"mode":"out-in"}},[_c('router-view')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }